var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { range } from "lodash";
import React, { Fragment } from "react";
import { useTableContext } from "../../hooks/useTableContext";
import { Placeholder } from "../../Placeholder";
import { V2Table } from "./Table";
import { V2TableCell } from "./TableCell";
import { V2TableRowComponent } from "./TableRow";
export function TableLoading(props) {
    var _a;
    var gridClassName = useTableContext().gridClassName;
    var rowIndex = 0;
    return (React.createElement(Fragment, null, range((_a = props === null || props === void 0 ? void 0 : props.loadingRows) !== null && _a !== void 0 ? _a : 4).map(function () {
        rowIndex++;
        return (React.createElement(V2TableRowComponent, __assign({ item: { dummy: "" }, rowIndex: rowIndex }, props, { key: rowIndex, gridClassName: gridClassName }), props.headings.map(function (heading, i) {
            return (React.createElement(V2TableCell, __assign({}, props, { heading: heading, colIndex: i + 1, key: i }),
                React.createElement(Placeholder, null)));
        })));
    })));
}
export function TableSkeleton(props) {
    return React.createElement(V2Table, __assign({}, props, { loading: true }));
}
